import { Table } from '~/components/Table/Table';
import { seriesIdParamSchema } from '~/schemas';
import { Link } from '~/components/Link/Link';
import { useParams } from '~/hooks/useParams';
import { Division } from '~/apis/ssf';

interface Props {
  divisions: Division[];
  isLoading: boolean;
}

function Row({ division }: { division: Division }) {
  const { seriesId } = useParams(seriesIdParamSchema.parse);

  return (
    <Table.Row>
      <Table.Col>
        <Link to={`/series/${seriesId}/divisions/${division.id}`}>{division.name}</Link>
      </Table.Col>
      <Table.Col>{division.results_per_round}</Table.Col>
      <Table.Col>{division.max_teams}</Table.Col>
    </Table.Row>
  );
}

export function DivisionListTable({ divisions, isLoading }: Props) {
  return (
    <Table bg="even">
      <Table.Head>
        <Table.Row>
          <Table.Col as="th">Division</Table.Col>
          <Table.Col as="th">Resultat per omgång</Table.Col>
          <Table.Col as="th">Max antal lag</Table.Col>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {isLoading ? (
          <Table.Loading cols={5} />
        ) : (
          divisions.map(division => <Row division={division} key={division.id} />)
        )}
      </Table.Body>
    </Table>
  );
}
